
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ComentariosApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/comentarios/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/comentarios/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static replyDelete(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/comentarios/replay/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getComentariosList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getComentarios(id,idCurso, token ) {  
         return $.ajax({  
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios?id="+id+"&curso="+idCurso,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(comentarios, token ) {          
      let comentariosEnvio = Object.assign({}, comentarios);
		let comando="POST";
		if (comentariosEnvio.id > 0) {
			comando="POST";			
		} 
		comentariosEnvio=JSON.stringify(comentariosEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: comentariosEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveComment(comentarios, token ) {          
      let comentariosEnvio = Object.assign({}, comentarios);
		let comando="POST";
		if (comentariosEnvio.id > 0) {
			comando="POST";			
		} 
		comentariosEnvio=JSON.stringify(comentariosEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios/comment",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: comentariosEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
     static saveImagen(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/comentarios/upload",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static editarComentario(comentario, token ) {          
      let comentariosEnvio = Object.assign({}, comentario);
		let comando="PUT";
		comentariosEnvio=JSON.stringify(comentariosEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: comentariosEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    

    static editarReplay(reply, token ) {          
      let replyEnvio = Object.assign({}, reply);
		let comando="PUT";
		replyEnvio=JSON.stringify(replyEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios/reply/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: replyEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static getComentariosCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/comentarios/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}